"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillMissingFormat = void 0;
// (C) 2020-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var DEFAULT_PERCENTAGE_FORMAT = "#,##0.00%";
/**
 * The function fills the format of the measure bucket item that does not have it set.
 *
 * @param item - bucket attribute or measure
 *
 * @returns a copy of bucket item with auto-generated format for measure
 *
 * @internal
 */
function fillMissingFormat(item) {
    if (sdk_model_1.isSimpleMeasure(item)) {
        var doesCompateRatio = sdk_model_1.measureDoesComputeRatio(item);
        var format = sdk_model_1.measureFormat(item);
        if (!format && doesCompateRatio) {
            return sdk_model_1.modifySimpleMeasure(item, function (measure) { return measure.format(DEFAULT_PERCENTAGE_FORMAT); });
        }
    }
    return item;
}
exports.fillMissingFormat = fillMissingFormat;
//# sourceMappingURL=fillMissingFormat.js.map